export default __webpack_public_path__ + "static/media/f-iluminacion.3788d6b2.png";